import React, { useEffect } from 'react';

import {
  PricingPlanPageContentProps,
  PricingPlanPageContentWithLoading,
} from './PricingPlanPageContent/PricingPlanPageContent';

import './PricingPlanPage.scss';

export interface PricingPlanPageProps extends PricingPlanPageContentProps {
  onLoad: () => void;
  isLoading: boolean;
  isOnboarding?: boolean;
}

export const PricingPlanPage = ({ onLoad, ...props }: PricingPlanPageProps) => {
  useEffect(() => {
    onLoad();
  }, [onLoad]);

  return (
    <div className="flex-box-column flex-align-center content pricing-plan-page">
      <div className="pricing-plan-page__container">
        <PricingPlanPageContentWithLoading {...props} />
      </div>
    </div>
  );
};
